import React, { useState, useContext, useEffect } from 'react';
import Banner from '../../b2b-common/Banner';
import B2BElementsExplorer from '../../b2b-common/B2BElementsExplorer';
import IndicatorCard from '../../b2b-indicators/components/IndicatorCard';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import { GenFrameworksContext, LoginContext } from '../../../App';
import FrameworkCard from '../components/FrameworkCard';

import './FrameworkSuitteExplorer.css';
import FrameworkSearchForm from '../components/FrameworkSearchForm';
import { fetchFrameworksData } from '../../../services/b2b-frameworks-apiService';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';

export const fetchAllFrameworks = async (loginData, setError, frameworkSuite) => {
    try {
        const paramsArray = [
            frameworkSuite,
            loginData.accessToken,
            true, // fetch images
            true, // include lelvel1s
        ];
        const fws = await fetchAPIDataWhileSettingState(fetchFrameworksData, paramsArray, null);
        return fws;
    } catch (error) {
        setError(error.message);
    }
};

const FrameworkSuitteExplorer = ({ title, frameworkSuite }) => {

    const { genericFrameworks } = useContext(GenFrameworksContext);
    const [iotFrameworks, setIotFrameworks] = useState(null);
    const [verticalFrameworks, setVerticalFrameworks] = useState(null);
    const [partnerFrameworks, setPartnerFrameworks] = useState(null);
    const [softwareFrameworks, setSoftwareFrameworks] = useState(null);

    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);
    const [fwIndicatorsData, setFwIndicatorsData] = useState([]);
    const [isSearching, setIsSearching] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    const [pageNumberLoading, setPageNumberLoading] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [selectedFramework, setSelectedFramework] = useState(null);

    useEffect(() => {
        const fetchFrameworks = async () => {
            if (frameworkSuite !== 'generic') { // generic is set in the LoginContext
                if (frameworkSuite === 'iot' && !iotFrameworks) {
                    const iotFws = await fetchAllFrameworks(loginData, setError, frameworkSuite);
                    setIotFrameworks(iotFws);
                } else if (frameworkSuite === 'vertical' && !verticalFrameworks) {
                    const verticalFws = await fetchAllFrameworks(loginData, setError, frameworkSuite);
                    setVerticalFrameworks(verticalFws);
                } else if (frameworkSuite === 'partner' && !partnerFrameworks) {
                    const partnerFws = await fetchAllFrameworks(loginData, setError, frameworkSuite);
                    setPartnerFrameworks(partnerFws);
                } else if (frameworkSuite === 'software' && !softwareFrameworks) {
                    const softwareFws = await fetchAllFrameworks(loginData, setError, frameworkSuite);
                    setSoftwareFrameworks(softwareFws);
                }
            }
            setFwIndicatorsData([]);
            setSelectedFramework(null);
        };

        fetchFrameworks();
    }, [loginData, frameworkSuite]);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSelectedFramework = (element) => {
        const framework = element.props.framework;
        //console.log("Selected framework: ", framework);
        setSelectedFramework(framework);
        setRefresh(true);
        setCurrentPage(1);
    }

    const SuiteFrameworks = (frameworkSuite === 'generic') ? genericFrameworks : (frameworkSuite === 'iot') ? iotFrameworks :
        (frameworkSuite === 'vertical') ? verticalFrameworks : (frameworkSuite === 'partner') ? partnerFrameworks : softwareFrameworks;

    return (
        <div className='genericfw-explorer-page-container'>
            <Banner message={title} />
            {SuiteFrameworks &&
                <ElementsCarousel
                    elements={SuiteFrameworks.map(framework =>
                        <FrameworkCard key={framework.frameworkId} framework={framework} />
                    )}
                    onElementSelect={handleSelectedFramework}
                />
            }
            {(selectedFramework) ? (
                <>
                    <FrameworkSearchForm
                        frameworkSuite={frameworkSuite}
                        title={"Framework indicators search form for: " + selectedFramework.frameworkName}
                        framework={selectedFramework}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        isSearching={isSearching}
                        setIsSearching={setIsSearching}
                        setIndicatorsData={setFwIndicatorsData}
                        setPagesCount={setPagesCount}
                    />
                    <B2BElementsExplorer
                        title="Framework indicators results"
                        isSearching={isSearching}
                        elementsData={fwIndicatorsData}
                        pagesCount={pagesCount}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                        pageNumberLoading={pageNumberLoading}
                        className="framework-indicators-explorer"
                        ElementComponent={IndicatorCard}
                        elementComponentPropName="indicator"
                        elementComponentHandlers={null}
                    />
                </>
            ) : null}
        </div>
    );
};

export default FrameworkSuitteExplorer;